// extracted by mini-css-extract-plugin
module.exports = {"container":"Container-module--container--3yf9y","is-wide":"Container-module--is-wide--2I_E8","isWide":"Container-module--is-wide--2I_E8"};